import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid, NPIDataGridColDef } from 'src/components/NPIDataGrid/NPIDataGrid';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import { AccountStatementTableData } from 'src/pages/ViewAccountStatementPage/types';

type TableProps = {
    loading: boolean;
    tableData: AccountStatementTableData[];
};

function StatementItemTable({ tableData, loading }: TableProps) {
    const maxHeight = '400';

    const STATEMENTS_TABLE_HEADERS: NPIDataGridColDef[] = [
        createColumnDef({
            field: 'transactionDate',
            headerName: 'Date/Time',
        }),
        createColumnDef({
            field: 'description',
            headerName: 'Transactions',
        }),
        createColumnDef({
            field: 'debit',
            headerName: 'Debit',
        }),
        createColumnDef({
            field: 'credit',
            headerName: 'Credit',
        }),
        createColumnDef({
            field: 'rollingBalance',
            headerName: 'Balance',
        }),
    ];

    return (
        <>
            {loading && <Loader />}
            <NPIDataGrid
                dataTestId="account-statements-table"
                rows={tableData}
                columns={STATEMENTS_TABLE_HEADERS}
                getRowId={(row) => {
                    return row.id;
                }}
                title="Account Statements"
                maxHeight={maxHeight}
            />
        </>
    );
}

export default StatementItemTable;
